import BadgerAccordion from 'badger-accordion'
import SmoothScroll from 'smooth-scroll'
import { $, each } from '../util'

const Accordion = (() => {
  const init = () => {
    const accordions = $('.js-badger-accordion')

    for (let i = 0; i < accordions.length; i++) {
      const openFirst = accordions[i].getAttribute('data-open-first') === 'true'

      const accordion = new BadgerAccordion(accordions[i], {
        openMultiplePanels: true
      })
      if (openFirst && accordions[i].children.length > 0) accordion.open(0)

      // for tickets when a reply is added
      const observer = new MutationObserver(mutationList => {
        mutationList.forEach(mutation => {
          if (mutation.type == 'childList') {
            accordion.calculateAllPanelsHeight()
          }
        })
      })
      observer.observe(accordions[i], {
        childList: true,
        subtree: true
      })

      // for tickets
      const closeButtons = accordions[i].querySelectorAll('.js-accordion-close')

      if (closeButtons.length) {
        for (let j = 0; j < closeButtons.length; j++) {
          closeButtons[j].addEventListener('click', () => {
            accordion.close(j)
          })
        }
      }
    }

    // Animation scroll on header click
    const accordionHeders = document.querySelectorAll('.js-badger-accordion-header')
    accordionHeders.forEach((accordionHeder) => {
      accordionHeder.addEventListener('click', () => {
        setTimeout(() => {
          const scroll = new SmoothScroll()
          scroll.animateScroll(
            accordionHeder,
            null,
            { offset: 150 }
          )
        }, 250)
      })
    })
  }

  return {
    init
  }
})()

export default Accordion



// WEBPACK FOOTER //
// app/javascript/scripts/components/Accordion.js